// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

// these functions are global so that's the reason why
// we can't use the function form of "use strict".

// define Array.prototype.indexOf for IE8
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(obj, start) {
         for (var i = (start || 0), j = this.length; i < j; i++) {
             if (this[i] === obj) { return i; }
         }
         return -1;
    };
}

function cw_check_disable_loading_buttons($){
  "use strict";
  var dospace = $('html').hasClass('lt-ie9');
  var disableIt = function($el) {
    $el.addClass("cw_disabled").addClass("cw_loading");
    if($el.is("a")) {
      var $a = $el;
      setTimeout(function(){
        // to please jslint...
        var dummy = ['javascript', ':', 'void(0)'].join('');
        $a.attr("href", dummy);
        $a.unbind('click');
        $a.click(function(e2){
          e2.preventDefault();
        });
      },1);
      if(dospace) {
        $a.attr('data-text', $a.text());
        $a.html(' ');
      }
    } else if ($el.is("button") || $el.is("input[type=submit]") || $el.is("input[type=button]") ) {
      var $btn = $el;
      setTimeout(function(){
        var onclick = $btn.attr("onclick");
        if (typeof onclick !== 'undefined' && onclick !== false) {
          $btn.attr("data-prev-onclick", onclick);
        }
        $btn.attr("onclick", "return false;");
      }, 1);
      if(dospace) {
        if($btn.is("button")) {
          $btn.attr('data-text', $btn.text());
          $btn.html(' ');
        } else {
          $btn.attr('data-text', $btn.attr('value'));
          $btn.attr('value', ' ');
        }
      }
    }
  };
  $('.cw_disable_on_click:not([type=submit])').on('click', function(){
    disableIt($(this));
  });
  $('form').each(function(){
    var $form = $(this);
    $form.on('submit', function(e){
      $form.find('.cw_disable_on_click[type=submit]').each(function(){
        disableIt($(this));
      });
    });
  });
}
if (typeof $ === typeof Function) { // jQuery defined?
  $(document).ready(function() {
    cw_check_disable_loading_buttons($);
    cw_populate_language_switch_urls();
  });
}

function cw_populate_language_switch_urls(){
  var alternates = $('link[rel=alternate][hreflang]')
  alternates.each(function(){
    var alter = $(this)[0];
    var l = $('#cw_main_international').find('.' + alter.hreflang + ' a')[0];
    if(l){
      l.href = alter.href;
    }
  });
  $('#cw_main_international .cw_dropmenu_content-wrapper ul li a').each(function(i, el){
    if (/(.*)\/errors\/not_found/i.test($(el).attr('href'))){
      $(this).attr('href', '/');
    }
  });
}

/* Function to switch language */
function reload_page_with_host(main_host, auction_host, locale) {
  "use strict";
  if (typeof event !== 'undefined') {
    if (event.preventDefault) {
      event.preventDefault();
    } else {
      event.returnValue = false;
    }
  }
  try {
    if(locale) {
      var alternate = $('link[rel=alternate][hreflang='+locale+']').last();
      if (alternate && alternate.attr('href')) {
        location.href = alternate.attr('href');
        return;
      }
    }

    // determine slug from full url
    var protocol_domain = location.protocol + "//" + document.domain + "/";
    var full_url = location.href;
    var slug_with_slash = full_url.replace(protocol_domain,"");
    var slug = slug_with_slash.replace("^/","");
    var new_domain, new_host, new_slug, main_old_domain, main_new_domain;

    // determine new domain
    if (location.host.match(/(veiling|encheres|auktion|auction)/)) {
      new_domain = auction_host;
    }
    else {
      new_domain = main_host;
    }
    // also convert subdomains
    if (slug.match(/(veiling(\.[a-z]+)?.catawiki|encheres(\.[a-z]+)?.catawiki|auktion(\.[a-z]+)?.catawiki|auction(\.[a-z]+)?.catawiki)/)) {
      new_host = auction_host.match(/.*(?=\.\w+)/);
      new_slug = slug.replace(/(veiling(\.[a-z]+)?.catawiki|encheres(\.[a-z]+)?.catawiki|auktion(\.[a-z]+)?.catawiki|auction(\.[a-z]+)?.catawiki)/, new_host);
    }
    else {
      new_host = main_host.match(/.*(?=\.\w+)/);
      new_slug = slug.replace(/(\.[a-z]+)?.catawiki/, new_host);
    }

    // also replace possible domain in slug
    main_old_domain = location.host.match(/\.catawiki\.[a-z.]+/);
    main_new_domain = new_domain.match(/\.catawiki\.[a-z.]+/);
    var re = new RegExp(main_old_domain, 'g');
    new_slug = new_slug.replace(re, main_new_domain);

    location.href = location.protocol + "//" + new_domain + "/" + new_slug;
    // alert(location.protocol + "//" + new_domain + "/" + new_slug);
  } catch(e) {
    location.href = main_host;
  }
}

function handle_enter(inField, e, func, arg1, arg2) {
  "use strict";
  var charCode;
  if (e && e.which) {
    charCode = e.which;
  } else if(window.event) {
    e = window.event;
    charCode = e.keyCode;
  }
  if(charCode == 13) {
    func(arg1,arg2);
  }
}

function goto_gallery_page(url, nr) {
  "use strict";
  location.href = url.replace('@page@',nr).replace('%40page%40',nr);
}

function cw_open_register_modal($, url) {
  "use strict";
  var type = 'ajax';
  if (!url) {
    return;
  }
  var open_callback = function(){};
  if($("html").hasClass("lt-ie10")) {
    var qschar = "?";
    if(url.indexOf("?")>7) {
      qschar = "&";
    }
    url += qschar+"load_v2=true";
    //console && console.log("Url before:"+url);
    if (url.indexOf('http://')>=0) {
      url = url.replace('http://','https://');
    } else {
      //console && console.log("Auction domain");
      var main_domain = document.domain.match(/(dev|staging)\.catawiki/) ? '' : 'www.';
      url = 'https://'+document.domain.replace(/(veiling|encheres|auktion|auction)\./,main_domain)+url;
    }
    //console && console.log("Url after:"+url);
    type = 'iframe';
    open_callback = function(){
      $(".mfp-content").css({width: '400px', height: '626px'});
    };
  }
  $.magnificPopup.open({
    items: {
      src: url
    },
    type: type,
    callbacks: {
      ajaxContentAdded: function() {
        $('.mfp-ajax-holder button.mfp-close').each(function(){
          $(this).appendTo($(this).closest('.mfp-ajax-holder'));
        });
        cw_check_disable_loading_buttons($);
        $('input, textarea').placeholder();
      },
      open: function(){
        open_callback();
      }
    }
  }, 0);
}

jQuery(function($) {
  function removeUserLocalStorage() {
    cw_store.remove('user_name');
    cw_store.remove('user_email');
    cw_store.remove('user_confirmed');
    cw_store.remove('user_created_at');
    cw_store.remove('fbFirstName');
    cw_store.remove('fbLastName');
    cw_store.remove('fbEmail');
    cw_store.remove('fbCity');
    cw_store.remove('fbPhone');
  }

  // turn logout to POST and remove user specific local storage
  $('#cw_logout').click(function(e) {
    removeUserLocalStorage();

    var form = $("<form/>", {
      action: this.href,
      method: 'POST'
    });
    if (document.location.hostname.indexOf('www') != -1) {
      var hiddenInput = $("<input/>", {
        name: 'token',
        value: window.App.NotificationService.RetrieveToken()
      });
    }
    form.append(hiddenInput);
    $(document.body).append(form);
    form.submit();
    e.preventDefault();
    return false;
  });


  // Define value for login form if exists
  var tokenFormInput = $('#login_form input[name=token]');
  if (tokenFormInput.length > 0 && window.App.NotificationService.RetrieveToken() !== null ) {
    tokenFormInput.val(window.App.NotificationService.RetrieveToken());
  }
});
